import React from 'react';

import {Maybe, SanityEditorial} from 'types/generated';

import {GridCard} from './GridCard';

interface EditorialHomepageHeroProps {
  featuredArticle: Maybe<SanityEditorial>;
  secondArticle: Maybe<SanityEditorial>;
  thirdArticle: Maybe<SanityEditorial>;
}

export const EditorialHomepageHero: React.FC<EditorialHomepageHeroProps> = (props: EditorialHomepageHeroProps) => {
  return (
    <section className="px-gutter bg-white module-spacing" data-module="editorialHomepageHero">
      <div className="wrapper-default grid grid-cols-6 sm:grid-cols-12 gap-8 sm:gap-y-[100px]">
        <GridCard
          cardColClasses={'grid col-span-full sm:grid-cols-12 sm:gap-x-[26px] items-center'}
          title={props.featuredArticle?.title}
          category={
            props.featuredArticle?.editorialCategory
              ? props.featuredArticle?.editorialCategory.title
              : props.featuredArticle?.category
          }
          image={props.featuredArticle?.heroImage}
          imageClasses={'grid col-span-full sm:col-span-6 pb-[75%]'}
          contentClasses={'col-span-full sm:col-span-6 mt-4 lg:mt-7 sm:pl-[50px]'}
          titleClasses={'type-gamma sm:type-alpha'}
          eyebrowClasses={''}
          slug={props.featuredArticle?.slug?.current || ''}
          editorialCategory={props.featuredArticle?.editorialCategory}
        />
        <GridCard
          cardColClasses={'grid col-span-6 gap-x-4 items-center sm:items-start content-start'}
          title={props.secondArticle?.title}
          category={
            props.secondArticle?.editorialCategory
              ? props.secondArticle.editorialCategory.title
              : props.secondArticle?.category
          }
          image={props.secondArticle?.heroImage !== null ? props.secondArticle?.heroImage : null}
          imageClasses={'grid col-span-full pb-[68%] lg:h-[275px]'}
          contentClasses={'grid col-span-full mt-4 lg:mt-7'}
          titleClasses={'type-epsilon'}
          slug={props.secondArticle?.slug?.current}
          eyebrowClasses={''}
          editorialCategory={props.secondArticle?.editorialCategory}
        />
        <GridCard
          cardColClasses={'grid col-span-6 gap-x-4 items-center sm:items-start content-start'}
          title={props.thirdArticle?.title}
          category={
            props.thirdArticle?.editorialCategory
              ? props.thirdArticle.editorialCategory.title
              : props.thirdArticle?.category
          }
          image={props.thirdArticle?.heroImage !== null ? props.thirdArticle?.heroImage : null}
          imageClasses={'grid col-span-full pb-[68%] lg:h-[275px]'}
          contentClasses={'grid col-span-full mt-4 lg:mt-7'}
          titleClasses={'type-epsilon'}
          slug={props.thirdArticle?.slug?.current}
          eyebrowClasses={''}
          editorialCategory={props.thirdArticle?.editorialCategory}
        />
      </div>
    </section>
  );
};
